export const CONFIGURABLE = 'configurable';

export const SIMPLE = 'simple';
